import { __awaiter } from "tslib";
import Config from "../config";
import { filterServicesByTypeAndID, isIpfsAddress, mapResponse, resolveIpfsAddressToGateway, } from "./utils";
import { DIDService } from "./types";
class IPFSStore {
    constructor(did, resolver) {
        this.did = did;
        this.resolver = resolver;
    }
    set(key, value) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error("Method not supported.");
        });
    }
    save() {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error("Method not supported.");
        });
    }
    get(key) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const { didDocument } = yield this.resolver.resolve(this.did);
            if (!didDocument) {
                return null;
            }
            const publicProfileServices = filterServicesByTypeAndID((_a = didDocument.service) !== null && _a !== void 0 ? _a : [], DIDService.DATASTORE, "publicRemoteProfile");
            if (publicProfileServices.length > 0 &&
                isIpfsAddress(publicProfileServices[0].serviceEndpoint)) {
                const { ipfsMainGateway } = Config;
                const dataSrcAddress = resolveIpfsAddressToGateway((_b = publicProfileServices[0]) === null || _b === void 0 ? void 0 : _b.serviceEndpoint, ipfsMainGateway);
                const result = yield fetch(dataSrcAddress);
                return result
                    .json()
                    .then((data) => mapResponse(data.publicRemoteProfile));
            }
            return null;
        });
    }
}
export default IPFSStore;
